import { useContext } from 'react';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getCurrentUser } from '@arrived/api_v2';
import { AuthContext } from '@arrived/auth';
import { GENERIC_ERROR, User } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { currentUserKeyFn } from './users.keys';

export function useGetCurrentUserQuery(options?: UseQueryOptions<User>): UseQueryResult<User> {
  const { isAuthenticated, logout } = useContext(AuthContext);
  return useQuery(currentUserKeyFn(), () => getCurrentUser(), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: (options?.enabled ?? true) && isAuthenticated,
    onError: async (error) => {
      const usedError = error as AxiosError;
      options?.onError?.(error);

      // If the user is not authenticated according to abacus, logout
      if (usedError.response?.status === 401 && usedError.response?.statusText === GENERIC_ERROR.UNAUTHORIZED) {
        await logout();
      }
    },
  });
}
